import { useEffect, useState } from 'react'

/**
 * El tiempo que lleva abierta la llamada, en grande y arriba.
 *
 * Los tramos los puso José en la reunión: verde por debajo de 20 minutos,
 * amarillo entre 20 y 25, y rojo destellante a partir de 25 sin cerrarla.
 */
const AMARILLO = 20 * 60
const ROJO = 25 * 60

const COLORES = {
  verde: 'bg-marca-50 text-marca-800 dark:bg-marca-700/20 dark:text-marca-100',
  amarillo: 'bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-200',
  rojo: 'bg-red-600 text-white animate-pulse',
}

const reloj = (segundos: number): string => {
  const minutos = Math.floor(segundos / 60)
  return `${String(minutos).padStart(2, '0')}:${String(segundos % 60).padStart(2, '0')}`
}

export function Cronometro({ desde, parado }: { desde: string; parado?: boolean }) {
  // Las fechas llegan en UTC sin zona; sin la Z el navegador las lee como locales.
  const inicio = Date.parse(desde.includes('T') ? desde : `${desde.replace(' ', 'T')}Z`)
  const [ahora, setAhora] = useState(() => Date.now())

  useEffect(() => {
    if (parado) return
    const id = setInterval(() => setAhora(Date.now()), 1000)
    return () => clearInterval(id)
  }, [parado])

  if (Number.isNaN(inicio)) return null

  const segundos = Math.max(0, Math.floor((ahora - inicio) / 1000))
  const color = segundos >= ROJO ? 'rojo' : segundos >= AMARILLO ? 'amarillo' : 'verde'

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-xl px-3 py-1.5 text-xl font-bold tabular-nums ${
        parado ? 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400' : COLORES[color]
      }`}
      title={parado ? 'La llamada ya está cerrada' : 'Tiempo desde que se abrió la llamada'}
      aria-label={`Tiempo de llamada ${reloj(segundos)}`}
    >
      {reloj(segundos)}
    </span>
  )
}
